import { db } from '@/db/db';
import type { ExhibitorContext } from '@/db/models';

export const cacheRepository = {
  async setExhibitorContext(context: Omit<ExhibitorContext, 'key' | 'cachedAtUtc'>): Promise<void> {
    await db.exhibitorContext.put({
      key: 'current',
      ...context,
      cachedAtUtc: new Date().toISOString()
    });
  },

  async getExhibitorContext(): Promise<ExhibitorContext | undefined> {
    return db.exhibitorContext.get('current');
  },

  async clear(): Promise<void> {
    await db.exhibitorContext.delete('current');
  }
};
